@if (disableEdit) {
  @if (readOnlyLabel) {
    <span>{{ readOnlyLabel }}</span>
  } @else {
    <span class="italic font-light">{{ placeholder || 'Select location' }}</span>
  }
} @else {
  <div [formGroup]="form">
    <p-select
      class="w-full"
      styleClass="w-full"
      [placeholder]="placeholder"
      [options]="displayedOptions"
      formControlName="location"
      appendTo="body"
      [filter]="true"
      filterBy="name,region,domesticRegion"
      [virtualScroll]="virtualScroll"
      [virtualScrollItemSize]="virtualScrollItemSize"
      (onBlur)="markAsTouched()">
      <ng-template pTemplate="selectedItem">
        @if (!value) {
          <span class="text-surface-500">{{ placeholder || 'Select location' }}</span>
        } @else {
          <span>{{ value.name }}</span>
        }
      </ng-template>
      <ng-template let-location pTemplate="item">
        <span class="font-medium">{{ location.name }}</span>
      </ng-template>
    </p-select>
  </div>
}
